import React from 'react'
import {Card, CardImg, BodyCard, ProductName, Price, RegularPrice} from '../../theme/theme'
import {useHistory} from "react-router-dom"
import CornerRibbon from "react-corner-ribbon";
import AddFrom from '../AddFrom'
import {CategoriesDetailContainer,
    CategoriesDetailContainerRow,
    ProductNameRow,
    PriceRow,
    RegularPriceRow,
    DescriptionRow,
    DivRow,
    CardImgRow,
    CardRow,
    ContainerGeneralMap,
    Line,
    LineNameRow,
    ContainerCardCategoryDetail} from "./style";
import {DiscountContainerCategoryDetail} from "../Discount/style"
import CardSkeleton from '../CardSkeleton'
import useView from '../../hooks/useView'
import CurrencyFormat from '../../utils/currencyFormat';
import {calculatePriceWithTax, returnProduct} from '../../utils/formatData'


const CardCategoryDetail = ({ homeState, productList, typeList, loading, isMobile, skeletonCardsRows = 1 , showAsGrid = false}: any) => {
    const history = useHistory()
    const {display} = useView()
    const handleRedirectProductInfo = (idCategory:any, idProduct:any)=>{
        history.push(`/vende/${homeState.catalogueUrlName}/product-info/${idCategory}/${idProduct}`)
    }
    const qtySubstring = isMobile ? 40 : 685

    return (
        loading ? 
        <>
            {display === "desktop" ?
                <CardSkeleton cards={skeletonCardsRows * 4} width={200} height={200} showAsGrid={showAsGrid}/> :
                <CardSkeleton cards={skeletonCardsRows * 2} showAsGrid={showAsGrid}/>
            }
        </>
        :(
            typeList === "colum" ? (
                
            <CategoriesDetailContainer>
                {
                        productList.map((product: any, index:any) => (
                                <ContainerCardCategoryDetail lastImage={isMobile} key={"container"+index}>
                                    {
                                        <Card discount={returnProduct(product, 'discountRate')} secondImage={product.img[1] ? product.img[1] : product.img[0]} key={"card" + index} className="boxShadow-node">
                                        {returnProduct(product, 'discountRate') > 0 && <CornerRibbon backgroundColor="#ff0000" fontColor="#f0f0f0" containerStyle={{}}>
                                                        <AddFrom product={product} field={"discountRate"} fontSize={display === "desktop" ? ".6rem" : ".5rem"} fontWeight="600" br={true} />
                                                        <span style={{fontFamily: 'Roboto', fontWeight: 700, fontSize: '1.3em'}}>
                                                            {' '+returnProduct(product, 'discountRate')}%off
                                                        </span>
                                                    </CornerRibbon> }
                                        <>
                                            <a onClick={() => handleRedirectProductInfo(product.categories, product.id)}>
                                                <CardImg src={product.img[0]} showInGrid={showAsGrid}  />
                                            </a>
                                            <BodyCard>
                                                <ProductName text={product.title} />
                                                {returnProduct(product, 'discountRate') > 0 ?
                                                    <>
                                                        <RegularPrice>
                                                            <AddFrom product={product} fontSize="1rem"/> 
                                                            <CurrencyFormat amount={returnProduct(product, 'netAmount') !== 0 ? calculatePriceWithTax(returnProduct(product)) : returnProduct(product, 'amount')}/>
                                                        </RegularPrice>
                                                        <Price>
                                                            <AddFrom product={product} /> <CurrencyFormat amount={returnProduct(product, 'amount')}/>
                                                        </Price>
                                                    </>
                                                    :
                                                    <Price>
                                                        <AddFrom product={product} /> <CurrencyFormat amount={returnProduct(product, 'amount')}/>
                                                    </Price>
                                                }
                                            </BodyCard>
                                        </>
                                        </Card>
                                    }
                                </ContainerCardCategoryDetail>
                        ))
                    }
            </CategoriesDetailContainer>
    ) : (
            <CategoriesDetailContainerRow>
                {
                    productList.length !== 0 &&
                        
                        productList.map((product: any, index:any) => (
                            <>
                                    {
                                    <>
                                    <ContainerGeneralMap>
                                        <CardRow display={display} discount={returnProduct(product, 'discountRate')} secondImage={product.img[1] ? product.img[1] : product.img[0]} key={"card"+index}>
                                            {returnProduct(product, 'discountRate')  > 0 && <CornerRibbon backgroundColor="#ff0000" fontColor="#f0f0f0" containerStyle={{}}>
                                                        <AddFrom product={product} field={"discountRate"} fontSize={display === "desktop" ? ".6rem" : ".5rem"} fontWeight="600" br={true} />
                                                        <span style={{fontFamily: 'Roboto', fontWeight: 700, fontSize: '1.3em'}}>
                                                            {' '+returnProduct(product, 'discountRate')}%off
                                                        </span>
                                                    </CornerRibbon> }    
                                            <a onClick={() => handleRedirectProductInfo(product.categories, product.id)}>
                                                <CardImgRow  src={product.img[0]}  />
                                            </a>
                                        </CardRow>
                                        <DivRow>
                                            <ProductNameRow>{product.title}</ProductNameRow>
                                            {
                                                !isMobile &&
                                                <LineNameRow />
                                            }
                                            {returnProduct(product, 'discountRate') > 0 ?
                                            <div  style={{display: 'block'}} >
                                                <RegularPriceRow>
                                                    <AddFrom product={product} fontSize="1rem"/> 
                                                    <CurrencyFormat amount={returnProduct(product, 'netAmount') !== 0 ? calculatePriceWithTax(returnProduct(product)) : returnProduct(product, 'amount')}/>
                                                </RegularPriceRow>
                                                <PriceRow>
                                                    <CurrencyFormat amount={returnProduct(product, 'amount')}/>
                                                </PriceRow>
                                            </div>
                                            :
                                            <PriceRow>
                                                <AddFrom product={product} /> <CurrencyFormat amount={returnProduct(product, 'amount')}/>
                                            </PriceRow>
                                            }
                                            <DescriptionRow>{
                                                product.description.substring(0,qtySubstring)}{product.description.length >= qtySubstring && '...'}</DescriptionRow>
                                        </DivRow>
                                    </ContainerGeneralMap>
                                        <Line />
                                        </>
                                    }
                            </>
                        ))
                }
            </CategoriesDetailContainerRow>
           )
        )
    )
}

export default CardCategoryDetail